import { Box } from "@mui/material";
import clsx from "clsx";
import { useEffect, useRef, useState } from "react";

import slotReelBg from "../../../assets/imgs/slot/slot_reel_bg.png";
import slotReelHighlight from "../../../assets/imgs/slot/slot_reel_bg_highlight.png";

import { SlotReelSymbol } from "../../../constants/enum/slot";
import { SlotSymbolIcons } from "../../../constants/slot";
import {
  startSpeedDownAnimation,
  startSpeedUpAnimation,
  startSpinningAnimation,
} from "./helper/animation";
import { getRandomSymbols } from "./helper/reel";

import useStyles from "./index.styles";

const SpinningCount = 2;
const SpinningSubDuration = 0.3;

const SlotMachineReel = ({
  targetSymbol,
  delay,
  spinning,
  reelIndex,
  onCompleteReelAnimation,
}: {
  targetSymbol: SlotReelSymbol;
  delay: number;
  spinning: boolean;
  reelIndex: number;
  onCompleteReelAnimation: (reelIndex: number) => void;
}) => {
  const { classes } = useStyles();

  const tl = useRef<gsap.core.Timeline>();
  const reelRef = useRef<HTMLDivElement>();
  const reelContainerRef = useRef<HTMLDivElement>();
  const [reelSymbols, setReelSymbols] = useState(getRandomSymbols(4));
  const spinCount = SpinningCount + reelIndex;

  useEffect(() => {
    if (!spinning) return;

    // Start the spinning process after the specified delay
    setTimeout(() => {
      // Start speeding up the reel
      startSpeedUpAnimation(tl, reelRef, reelContainerRef, () => {
        // Start the spinning animation
        startSpinningAnimation(tl, reelRef, reelContainerRef, spinCount, () => {
          // Replace current reel with new symbol list
          const newSymbols = getRandomSymbols(4);
          setReelSymbols(newSymbols); // Update the state first

          // Start slowing down the reel after spinning for the specified duration
          setTimeout(() => {
            startSpeedDownAnimation(
              tl,
              reelRef,
              reelContainerRef,
              newSymbols,
              targetSymbol,
              () => {
                // Notify that the reel animation is complete
                onCompleteReelAnimation(reelIndex);
              }
            ); // Pass the updated symbols directly
          }, spinCount * SpinningSubDuration * 1000);
        });
      });
    }, delay * 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay, targetSymbol, spinning]);

  return (
    <Box className={classes.reelBgContainer} ref={reelContainerRef}>
      <Box component="img" src={slotReelBg} className={classes.reelBg} />

      <Box className={classes.reelContainer}>
        <Box className={clsx(classes.reel, "slotReel")} ref={reelRef}>
          {reelSymbols.map((symbol, index) => (
            <Box
              component="img"
              src={SlotSymbolIcons[symbol]} // Starting from random empty icon
              key={index}
              className={classes.reelSymbol}
            ></Box>
          ))}
        </Box>
      </Box>

      <Box
        component="img"
        src={slotReelHighlight}
        className={classes.reelHighlight}
      />
    </Box>
  );
};

export default SlotMachineReel;
